import { render, staticRenderFns } from "./ProjectFileAttachListPageExt.vue?vue&type=template&id=920de06a&scoped=true&lang=pug&"
import script from "./ProjectFileAttachListPageExt.vue?vue&type=script&lang=js&"
export * from "./ProjectFileAttachListPageExt.vue?vue&type=script&lang=js&"
import style0 from "./ProjectFileAttachListPageExt.vue?vue&type=style&index=0&id=920de06a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920de06a",
  null
  
)

export default component.exports